/** Phone Number Reports is only opened up to this one account (Barbara Jackson) for now. */
export const PHONE_NUMBER_REPORT_USER_IDS = ["afc5e5ab-4a79-4bb5-be77-0f814cd72fcf"];

export function canViewPhoneNumberReport() {
  try {
    const user = JSON.parse(localStorage.getItem("userDetail") || "{}");
    const userId = user?.user_id || user?.id;
    return !!userId && PHONE_NUMBER_REPORT_USER_IDS.includes(userId);
  } catch {
    return false;
  }
}
